export const FETCH_TODOS = 'todo/FETCH_TODOS';
export const FETCH_TODOS_RESPONSE = 'todo/FETCH_TODOS_RESPONSE';
export const FETCH_TODOS_FAILED = 'todo/FETCH_TODOS_FAILED';
